var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0443 10.7436C16.8128 12.9185 15.5805 14.9566 13.5413 16.1339C10.1534 18.0899 5.8213 16.9292 3.86529 13.5413L3.65696 13.1804M2.95506 9.25553C3.18656 7.08062 4.41888 5.04252 6.45804 3.86521C9.84595 1.9092 14.178 3.06998 16.1341 6.45789L16.3424 6.81873M2.91089 15.0545L3.52093 12.7778L5.79764 13.3879M14.2018 6.61124L16.4785 7.22128L17.0885 4.94458M9.99971 6.24956V9.99956L12.083 11.2496",
    stroke: "#505050",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJob);
export default __webpack_public_path__ + "static/media/job.b2c253d899f0da98953cc7ed4139f88e.svg";
export { ForwardRef as ReactComponent };